import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UniversalLoginService } from '@auth';

export const authenticatedGuard: CanActivateFn = async (): Promise<boolean> => {
  const authenticationService: AuthService = inject(AuthService);
  const universalLoginService = inject(UniversalLoginService);

  if (authenticationService.isLoggedIn()) {
    return true;
  }

  const isSessionRestored = await authenticationService.ensureValidSession({
    allowBackgroundRefresh: false,
    isSilentRefresh: false,
  });

  if (isSessionRestored) {
    return true;
  }

  universalLoginService.redirectToLogin(window.location.href);

  return false;
};
